import {createSlice} from "@reduxjs/toolkit";
import {DATA_LIMIT} from "../../app/constants";

const pendingReceipt = createSlice({
	name: "pendingReceipt",
	initialState: {
		loading: false,
		error: null,
		filter: {
			page: 1,
			limit: DATA_LIMIT
		},
		items: [],
		summary: {
			pending: 0,
			total: 0
		},
		pagination: {
			page: 1,
			limit: DATA_LIMIT,
			total: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
			state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.summary = action.payload.summary || {pending: 0, total: 0};
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			let objIndex = state.items.findIndex((item => item.id == action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
		setFilterWithDebounce(state, action) {}
	}
})

export const pendingReceiptActions = pendingReceipt.actions;
export const pendingReceiptReducer = pendingReceipt.reducer;
export const pendingReceiptItemsSelector = (state) => state.pendingReceipt.items;
export const pendingReceiptLoadingSelector = (state) => state.pendingReceipt.loading;
export const pendingReceiptErrorSelector = (state) => state.pendingReceipt.error;
export const pendingReceiptFilterSelector = (state) => state.pendingReceipt.filter;
export const pendingReceiptSummarySelector = (state) => state.pendingReceipt.summary;
export const pendingReceiptPaginationSelector = (state) => state.pendingReceipt.pagination;
